import { LANGUAGES, DICTIONARY_KEYS } from './consts';
import localize, { setLocalizationLanguage } from './localize';

export { localize, setLocalizationLanguage, LANGUAGES, DICTIONARY_KEYS };
